var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoad({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VideoAd",
    transform: "translate(-918 -344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8217",
    "data-name": "Rectangle 8217",
    transform: "translate(918 344)",
    fill: "#e8eaed",
    stroke: "#dee1e5",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46,
    height: 46,
    rx: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "video-camera-with-play-button",
    d: "M24.975,86.218a1.759,1.759,0,0,0-1.917.381l-3.351,3.351V87.908a2.635,2.635,0,0,0-2.635-2.634H2.635A2.635,2.635,0,0,0,0,87.908v9.7a2.635,2.635,0,0,0,2.635,2.634H17.072A2.635,2.635,0,0,0,19.707,97.6V95.561l3.351,3.352a1.759,1.759,0,0,0,3-1.244V87.844A1.759,1.759,0,0,0,24.975,86.218Zm-12.593,7.22L8.791,96.2a.861.861,0,0,1-1.385-.683V90a.861.861,0,0,1,1.385-.682l3.591,2.759a.861.861,0,0,1,0,1.365Z",
    transform: "translate(928.469 274.744)",
    fill: "#1b1c1d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoad);
export default __webpack_public_path__ + "static/media/videoad.3c741769c2c840aa76c629ac68375076.svg";
export { ForwardRef as ReactComponent };